module.exports = {
    /**
     * Load mixins for the component.
     */
    mixins: [
        require('./../mixins/register'),
        require('./../mixins/plans'),
        require('./../mixins/vat'),
        require('./../mixins/stripe')
    ],

    props: ['userData'],

    /**
     * The component's data.
     */
    data() {
        return {
            query: null,

            cardElement: null,

            coupon: null,
            invalidCoupon: false,

            country: null,
            taxRate: 0,

            registerForm: $.extend(true, new SparkForm({
                stripe_payment_method: '',
                plan: '',
                team: '',
                team_slug: '',
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                address: '',
                address_line_2: '',
                city: '',
                state: '',
                zip: '',
                country: 'US',
                vat_id: '',
                terms: false,
                coupon: null,
                invitation: null,
                phone: null,
                birthday: null
            }), Spark.forms.register),

            cardForm: new SparkForm({
                name: '',
                number: '',
                cvc: '',
                month: '',
                year: '',
            }),
            customGoogleErrors: {
                'name': null,
                'team_name': null,
            },
            userDataJSON: null,
            disabledDates: {
                from: new Date(), // Disable all dates after specific date
            }
        };
    },


    watch: {
        /**
         * Watch for changes on the entire billing address.
         */
        'currentBillingAddress': function(value) {
            if (!Spark.collectsEuropeanVat) {
                return;
            }

            this.refreshTaxRate(this.registerForm);
        },


        /**
         * Watch the team name for changes.
         */
        'registerForm.team': function(val, oldVal) {
            if (this.registerForm.team_slug === '' ||
                this.registerForm.team_slug === oldVal.toLowerCase().replace(/[\s\W-]+/g, '-')
            ) {
                this.registerForm.team_slug = val.toLowerCase().replace(/[\s\W-]+/g, '-');
            }
        },


        /**
         * Watch for changes on the selected plan.
         */
        selectedPlan(val) {
            if (!val || val.price === 0) {
                this.cardElement = null;
                return;
            }

            if (!this.cardElement) {
                this.$nextTick(() => {
                    this.cardElement = this.createCardElement('#card-element');
                });
            }
        }
    },


    /**
     * The component has been created by Vue.
     */
    created() {
        console.log("component pending 123 created")
        this.userDataJSON = JSON.parse(this.userData);
        this.registerForm.name = this.userDataJSON.name;
        this.getPlans();

        this.guessCountry();

        this.query = URI(document.URL).query(true);

        if (this.query.coupon) {
            this.getCoupon();

            this.registerForm.coupon = this.query.coupon;
        }

        if (this.query.invitation) {
            this.getInvitation();

            this.registerForm.invitation = this.query.invitation;
        }
    },


    methods: {
        remove_validations() {
            if ((this.registerForm.team).trim() !== '' && (this.registerForm.name).trim() !== '') {
                this.customGoogleErrors.name = '';
                this.customGoogleErrors.team_name = '';
            } else if ((this.registerForm.team).trim() !== '') {
                this.customGoogleErrors.team_name = '';
            } else if ((this.registerForm.name).trim() !== '') {
                this.customGoogleErrors.name = '';
            }


        },
        validate() {
            event.preventDefault();
            if ((this.registerForm.team).trim() === '' && (this.registerForm.name).trim() === '') {
                this.customGoogleErrors.name = 'Name Field is Required For Signin with Google/Microsoft';
                this.customGoogleErrors.team_name = 'Team Name Field is Required For Signin with Google/Microsoft';
            } else if ((this.registerForm.team).trim() === '') {
                this.customGoogleErrors.team_name = 'Team Name Field is Required For Signin with Google/Microsoft';
            } else if ((this.registerForm.name).trim() === '') {
                this.customGoogleErrors.name = 'Name Field is Required For Signin with Google/Microsoft';
            } else {
                // window.location = 'auth/register/google';
            }

        },
        /**
         * Attempt to guess the user's country.
         */
        guessCountry() {
            axios.get('/geocode/country')
                .then(response => {
                    if (response.data != 'ZZ' && response.data != '') {
                        this.registerForm.country = response.data;
                    }
                })
                .catch(response => {
                    //
                });
        },


        /**
         * Get the coupon specified in the query string.
         */
        getCoupon() {
            axios.get('/coupon/' + this.query.coupon)
                .then(response => {
                    this.coupon = response.data;
                })
                .catch(response => {
                    this.invalidCoupon = true;
                });
        },


        /**
         * Attempt to register with the application.
         */
        register() {
            this.cardForm.errors.forget();

            this.registerForm.busy = true;
            this.registerForm.errors.forget();

            if (!Spark.cardUpFront || this.registerForm.invitation || this.selectedPlan.price === 0) {
                return this.sendRegistration();
            }

            const payload = {
                name: this.cardForm.name,
                address: {
                    line1: this.registerForm.address || '',
                    line2: this.registerForm.address_line_2 || '',
                    city: this.registerForm.city || '',
                    state: this.registerForm.state || '',
                    postal_code: this.registerForm.zip || '',
                    country: this.registerForm.country || '',
                }
            };

            this.generateToken(secret => {
                this.stripe.handleCardSetup(secret, this.cardElement, {
                    payment_method_data: {
                        billing_details: payload
                    }
                }).then(response => {
                    if (response.error) {
                        this.cardForm.errors.set({
                            card: [
                                response.error.message
                            ]
                        });

                        this.registerForm.busy = false;
                    } else {
                        this.sendRegistration(response.setupIntent.payment_method);
                    }
                });
            });
        },

        getDataTeamAndName() {

            this.registerForm.busy = true;
            this.registerForm.errors.forget();

            let payload = {
                'team_name': this.registerForm.team,
                'name': this.registerForm.name,
                'team': this.invitation,
            }
            axios.post('register/getData', payload)
                .then(response => {
                    this.registerForm.busy = false;
                    console.log(response)
                    if (this.invitation == null) {
                        if (this.customGoogleErrors.team_name == '' && this.customGoogleErrors.name == '') {
                            window.location = response.data.url;
                        }
                    } else {
                        if (this.customGoogleErrors.name == '') {
                            window.location = response.data.url;
                        }
                    }
                }).catch(err => {
                    console.log('error', err)
                });
        },

        getDataTeamAndNameMicrosoft() {
            this.registerForm.busy = true;
            this.registerForm.errors.forget();

            let payload = {
                'team_name': this.registerForm.team,
                'name': this.registerForm.name,
                'team': this.invitation,
            }
            axios.post('register/getDataMicrosoft', payload)
                .then(response => {
                    this.registerForm.busy = false;

                    console.log(response, response.config.data, response.data.url, this.customGoogleErrors.team_name == '');
                    if (this.invitation == null) {
                        if (this.customGoogleErrors.team_name == '' && this.customGoogleErrors.name == '') {
                            window.location = response.data.url;
                        }
                    } else {
                        if (this.customGoogleErrors.name == '') {
                            window.location = response.data.url;
                        }
                    }
                }).catch(err => {
                    console.log('error', err)
                });
        },

        /*
         * After obtaining the Stripe token, send the registration to Spark.
         */
        sendRegistration(paymentMethod) {
            this.registerForm.stripe_payment_method = paymentMethod;

            Spark.post('/register-pending', this.registerForm)
                .then(response => {
                    window.location = response.redirect;
                });
        },
        /**
         *To Format birthday date for registration form.
         */
        fixDate(event){
            if(!moment(event).isValid()){
                if (event){
                    this.registerForm.errors.errors.birthday = ["Not a valid date."];
                }else {
                    delete this.registerForm.errors.errors.birthday
                }
                this.registerForm.birthday = null;
            }else {
                delete this.registerForm.errors.errors.birthday
                this.registerForm.birthday = moment(event).format('MM/DD/yyyy');
            }
        },
    },


    computed: {
        /**
         * Determine if the selected country collects European VAT.
         */
        countryCollectsVat() {
            return this.collectsVat(this.registerForm.country);
        },


        /**
         * Get the displayable discount for the coupon.
         */
        discount() {
            if (this.coupon) {
                if (this.coupon.percent_off) {
                    return this.coupon.percent_off + '%';
                } else {
                    return Vue.filter('currency')(this.coupon.amount_off / 100);
                }
            }
        },


        /**
         * Get the current billing address from the register form.
         *
         * This used primarily for watching.
         */
        currentBillingAddress() {
            return this.registerForm.address +
                this.registerForm.address_line_2 +
                this.registerForm.city +
                this.registerForm.state +
                this.registerForm.zip +
                this.registerForm.country +
                this.registerForm.vat_id;
        }
    }
};
